import { FC } from 'react';
import { GiftShop_Card } from '../../../../generated/mlmbox/types/gift_shop';
import {
    batGray,
    batGreen,
    camO,
    camR,
    done,
    doneG,
    errorIcon,
    moderationIcon,
    prize,
    prizeGray,
    watch,
} from '../../../../assets';
import './MarketCard.scss';

import { Status_Transaction } from '../../../../generated/mlmbox/types/status';
import { useTranslation } from 'react-i18next';
import Stick from '../../../../shared/ui/Stick/Stick';
import { useNavigate } from 'react-router';

const MarketCard: FC<GiftShop_Card & { balanceAvaible: number; needReviewCardIds: number[] }> = ({
    needReviewCardIds,
    balanceAvaible,
    imageSrc,
    title,
    pointsNeeded,
    released,
    reviewApproved,
    transaction,
    id,
}) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    function getColor() {
        if (!released) {
            if (Number(pointsNeeded) > Number(balanceAvaible)) return '#8993A7';
            else {
                return '#2FF87F';
            }
        }

        if (released && !transaction) {
            // if (Number(pointsNeeded) > Number(balanceAvaible)) return '#8993A7';
            // else {
            //     return '#2FF87F';
            // }
            return '#FF4E63';
        }
        if (released && transaction && !reviewApproved && transaction.statusId === Status_Transaction.SUCCESS)
            return '#FF4E63';
        if (released && transaction) {
            if (transaction.statusId === Status_Transaction.PROCESSING) return '#FFA34E';
            if (transaction.statusId === Status_Transaction.SUCCESS) return '#8993A7';
            if (transaction.statusId === Status_Transaction.REJECTED) return '#FF4E63';
        }
        return '';
    }

    function getIcon() {
        if (!released) {
            if (Number(pointsNeeded) > Number(balanceAvaible)) return batGray;
            else {
                return batGreen;
            }
        }

        if (released && !transaction) {
            // if (Number(pointsNeeded) > Number(balanceAvaible)) return batGray;
            // else {
            //     return batGreen;
            // }
            return errorIcon;
        }
        if (released && transaction && !reviewApproved && transaction.statusId === Status_Transaction.SUCCESS)
            return camR;
        if (released && transaction) {
            if (transaction.statusId === Status_Transaction.PROCESSING) return watch;
            if (transaction.statusId === Status_Transaction.SUCCESS) return doneG;
            if (transaction.statusId === Status_Transaction.REJECTED) return errorIcon;
        }
        return '';
    }

    function getTitle() {
        if (!released)
            return `${
                Math.round((100 * Number(balanceAvaible)) / Number(pointsNeeded)) > 100
                    ? 100
                    : Math.round((100 * Number(balanceAvaible)) / Number(pointsNeeded))
            }%`;

        if (released && !transaction) {
            // return `${
            //     Math.round((100 * Number(balanceAvaible)) / Number(pointsNeeded)) > 100
            //         ? 100
            //         : Math.round((100 * Number(balanceAvaible)) / Number(pointsNeeded))
            // }%`;

            return 'Завершите вывод';
        }

        if (released && transaction && !reviewApproved && transaction.statusId === Status_Transaction.SUCCESS)
            return t('rew');
        if (released && transaction) {
            if (transaction.statusId === Status_Transaction.PROCESSING) return t('pro');
            if (transaction.statusId === Status_Transaction.SUCCESS) return t('don');
            if (transaction.statusId === Status_Transaction.REJECTED) return t('er');
        }
        return '';
    }

    return (
        <div
            className="market-card"
            onClick={() => {
                if (released && !transaction && !needReviewCardIds.length) {
                    navigate(`/buy-card/${id}?notransaction=true`);
                    return;
                }
                navigate(`/card/${id}`);
            }}>
            <div className="market-card__img">
                <img
                    className="img"
                    src={`${import.meta.env.VITE_API_URL}/${imageSrc}`}
                    alt=""
                />

                <div className="market-card__img--stick">
                    {
                        <Stick
                            color={getColor()}
                            img={getIcon()}
                            title={getTitle()}
                        />
                    }
                </div>
            </div>
            <div className="market-card__info">
                <h1>{title}</h1>
                <p style={{ color: balanceAvaible >= Number(pointsNeeded) && !reviewApproved ? '#2FF87F' : '#8993A7' }}>
                    <img
                        src={balanceAvaible >= Number(pointsNeeded) && !reviewApproved ? prize : prizeGray}
                        alt=""
                    />
                    {Number(pointsNeeded).toLocaleString()}
                </p>
            </div>
        </div>
    );
};

export default MarketCard;
